<script lang="ts">

    import { getContext } from 'svelte';
    import { navigate } from "svelte-routing";
    import ResetPasswordPopup from './ResetPasswordPopup.svelte';
    const { open } = getContext('simple-modal');

    open(ResetPasswordPopup, {}, {}, {
        onClose: () => {
            navigate("/", { replace: true });
        }
    });

</script>

<div>

</div>

<style lang="scss">

</style>